import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "total-contributions" }

import {CalendarHeatmap} from '@silverwind/vue3-calendar-heatmap';
import {onMounted, ref} from 'vue';
import type {Value as HeatmapValue, Locale as HeatmapLocale} from '@silverwind/vue3-calendar-heatmap';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityHeatmap',
  props: {
    values: {},
    locale: {}
  },
  setup(__props: any) {

// TODO: Switch to upstream after https://github.com/razorness/vue3-calendar-heatmap/pull/34 is merged


const colorRange = [
  'var(--color-secondary-alpha-60)',
  'var(--color-secondary-alpha-60)',
  'var(--color-primary-light-4)',
  'var(--color-primary-light-2)',
  'var(--color-primary)',
  'var(--color-primary-dark-2)',
  'var(--color-primary-dark-4)',
];

const endDate = ref(new Date());

onMounted(() => {
  // work around issue with first legend color being rendered twice and legend cut off
  const legend = document.querySelector<HTMLElement>('.vch__external-legend-wrapper');
  legend.setAttribute('viewBox', '12 0 80 10');
  legend.style.marginRight = '-12px';
});

function handleDayClick(e: Event & {date: Date}) {
  // Reset filter if same date is clicked
  const params = new URLSearchParams(document.location.search);
  const queryDate = params.get('date');
  // Timezone has to be stripped because toISOString() converts to UTC
  const clickedDate = new Date(e.date.getTime() - (e.date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10);

  if (queryDate && queryDate === clickedDate) {
    params.delete('date');
  } else {
    params.set('date', clickedDate);
  }

  params.delete('page');

  const newSearch = params.toString();
  window.location.search = newSearch.length ? `?${newSearch}` : '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.locale.textTotalContributions), 1 /* TEXT */),
    _createVNode(_unref(CalendarHeatmap), {
      locale: _ctx.locale.heatMapLocale,
      "no-data-text": _ctx.locale.noDataText,
      "tooltip-unit": _ctx.locale.tooltipUnit,
      "end-date": endDate.value,
      values: _ctx.values,
      "range-color": colorRange,
      onDayClick: _cache[0] || (_cache[0] = ($event: any) => (handleDayClick($event))),
      "tippy-props": {theme: 'tooltip'}
    }, null, 8 /* PROPS */, ["locale", "no-data-text", "tooltip-unit", "end-date", "values"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})